import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
import { SrOnly } from '../../Helper';
import Svg from '../../Svg';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Switch-root_2IXOn",
  "trigger": "Switch-trigger_tzV50",
  "pill": "Switch-pill_2Koxq",
  "handle": "Switch-handle_2fE4N",
  "icon": "Switch-icon_2RjyO",
  "iconOn": "Switch-iconOn_onjsx Switch-icon_2RjyO",
  "iconOff": "Switch-iconOff_26IAo Switch-icon_2RjyO",
  "default": "Switch-default_1I8Wz",
  "compact": "Switch-compact_1olwT",
  "label": "Switch-label_3psW9"
};
function Switch({
  id,
  name,
  value,
  children,
  checked,
  defaultChecked,
  disabled,
  icon: iconProp,
  variant = 'default',
  classes,
  className,
  inputProps,
  onChange,
  ...extraProps
}) {
  const classOf = key => classes?.[key] || '';
  const triggerClasses = clsx(styles.trigger, classOf('trigger'));
  const labelClasses = clsx(styles.label, classOf('label'));
  const rootClasses = clsx(styles.root, styles[variant], className, classOf('root'));
  return /*#__PURE__*/_jsxs(Base, {
    position: "relative",
    flex: true,
    gap: variant === 'default' ? 'spacing-2x' : undefined,
    className: rootClasses,
    ...extraProps,
    children: [/*#__PURE__*/_jsx("input", {
      type: "checkbox",
      role: "switch",
      id: id || name,
      name: name,
      value: value,
      defaultChecked: defaultChecked,
      checked: checked,
      disabled: disabled,
      className: triggerClasses,
      onChange: onChange,
      ...inputProps
    }), /*#__PURE__*/_jsx(Base, {
      flexShrink0: true,
      className: styles.pill
    }), /*#__PURE__*/_jsx(Base, {
      grid: true,
      placeItemsCenter: true,
      boxSizing: "border",
      className: styles.handle,
      children: iconProp && Svg.has(iconProp) ? /*#__PURE__*/_jsx(Svg, {
        name: iconProp,
        className: styles.icon
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Svg, {
          name: "miniCheckmark",
          className: styles.iconOn
        }), /*#__PURE__*/_jsx(Svg, {
          name: "miniCrossBold",
          className: styles.iconOff
        })]
      })
    }), /*#__PURE__*/_jsx(Base, {
      tagName: "label",
      weight: "regular",
      className: labelClasses,
      htmlFor: name,
      children: variant === 'compact' ? /*#__PURE__*/_jsx(SrOnly, {
        children: children
      }) : children
    })]
  });
}
export default Switch;